import { Space } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { FlexContainerText } from "@/modules/flex-container";

const Info = ({ user }) => {
  const { t } = useTranslation();

  const { name, email, organization } = user;

  return (
    <Space orientation="vertical" size="middle">
      {name && (
        <FlexContainerText value={name} label={t("user:form.name.label")} />
      )}
      {email && (
        <FlexContainerText value={email} label={t("user:form.email.label")} />
      )}
      {organization && (
        <FlexContainerText
          value={organization.name}
          label={t("user:form.organization.label")}
        />
      )}
    </Space>
  );
};

Info.propTypes = {
  user: PropTypes.object.isRequired,
};

export default Info;
